import Graph from "react-graph-vis";
import GraphData from './GraphData'
import { ID, isNode } from './GraphData'
import { v4 as uuidv4 } from 'uuid';
import React, { useState, useEffect, useRef } from 'react';
import modal from './Modal'
import * as cst from './cst'
import './App.css';

interface GraphComponentProps {
  graphRef: React.RefObject<any>
  graphData: GraphData
  setNetwork: Function
  updateSelected: Function
  handleClick: Function
}

export const GraphComponent : React.FC<GraphComponentProps> = ({ graphRef, graphData, setNetwork, updateSelected, handleClick}) => {
  const options = {
    physics: {
      enabled: false
    },
    interaction: {
      dragNodes : false
    },
    nodes:{
      color: cst.COLOR_TODO ,
      borderWidth:2,
      borderWidthSelected:3,
      shape: "box",
      widthConstraint:{
        maximum:150
      },
      font:{
        multi:"md" //* = bold; _ = italic; ` = mono
      },
      shapeProperties:{
        borderRadius:0
      },
      //Disabled. Very buggy.
      // chosen:{
      //   node:(values, id, selected, hovering) => {
      //     values.borderWidth = 4;
      //     values.shadow = {enabled: true, size:10}
      //   }
      // }
    },
    edges: {
      color: "#000000"
    },
    autoResize: true,
    height: '100%',
    width: '100%',
    layout: {
      randomSeed: 0,
      improvedLayout: false,
    }
  };
  const events = {
    afterDrawing: () => { //Doing it this way is murder. TODO.
      updateSelected()
    },
    click: handleClick
  };
  return (
    <div className="graph">
      <Graph
        ref={graphRef}
        graph={graphData.getGraph()}
        options={options}
        events={events}
        getNetwork={network => {
          setNetwork(network)
        }}
      />
    </div>
  );
}

